import styled from 'styled-components';

export const GalleryPriceOuterWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      padding-bottom: ${props.theme.spacing.large.l20};  
      justify-content: space-between;
  `
);

export const GalleryContainer = styled.div`
  cursor: pointer;
  display: flex;
  position: relative;
`;

export const GallerySmallLocationWrap = styled.div(
  props => `
      width: 32rem;
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
  `
);

export const LocationTopBlock = styled.div(
  props => `
      width: 100%;
      height: 15rem;  
      display: flex;
  `
);

export const LocationImage = styled.img(
  props => `
      width: 100%;
      height: 15rem;  
      cursor: pointer;
  `
);



export const PriceRatingWrap = styled.div(
  props => `
      width: 30rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      border-left: 1px dashed ${props.theme.colors.grey.lightdd};
      padding-left: ${props.theme.spacing.large.l11};  
  `
);

export const PriceInfoTopBlock  = styled.div(
  props => `
      width: 100%;
      display: flex;  
      flex-direction: column;
      margin-bottom: ${props.theme.spacing.base};
  `
);

export const PartnerRateWrap = styled.div(
  props =>`
      width: 100%;
      display: flex;
      padding: ${props.theme.spacing.small.s7} ${props.theme.spacing.base};
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
      background-image: ${props.bgColor || 'linear-gradient(75deg, #9f0469, #f5515f)'};
      position: relative;
      justify-content: space-between;
      align-items: center;
      // &:before {
      //     content: '';
      //     position: absolute;
      //     bottom: -6px;
      //     right: 20px;
      //     border-left: 5px solid transparent;
      //     border-right: 5px solid transparent;
      //     border-top: 6px solid #9f0469;
      // }
`);

export const PartnerRateText = styled.p(
  props => `
      font-size: ${props.theme.font.large.font16};
      color: ${props.txtColor || props.theme.colors.white.base};
      font-weight: ${props.theme.font.fontWeight.black};
      letter-spacing: ${props.theme.font.letterSpacing.base};
`);

export const SaveText = styled.p(
  props => `
      font-size: ${props.theme.font.small.font10};
      color: ${props.theme.colors.white.base};
      font-weight: ${props.theme.font.fontWeight.bold};
      letter-spacing: ${props.theme.font.letterSpacing.large};
  `
);


export const RoomInfoTopBlock = styled.div(
  props => `
      width:100%;
      display: flex;
      justify-content: space-between;
      padding: ${props.theme.spacing.base};
      border: solid 0.7px ${props.theme.colors.grey.lightdd};
      height: 16.5rem;
  `
);

export const RoomTypeInfoTop = styled.div(
  props => `
      width: 60%;
      display: flex;
      flex-direction: column;  
  `
);

export const RoomTypeText = styled.p(
  props => `
      font-size: ${props.theme.font.large.font16};
      color: ${props.theme.colors.black.base};
      font-weight: ${props.theme.font.fontWeight.black};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  `
);

export const PaxInfoTextTop = styled.p(
  props => `
      font-size: ${props.theme.font.small.font11};
      color: ${props.theme.colors.grey.base};
      padding-top: ${props.theme.spacing.small.s3};  
  `
);

export const AmenitesWrapTop = styled.div(
  props => `
      width: 100%;
      display: flex;
      flex-direction: column;
      padding-top: ${props.theme.spacing.small.s5};
  `
);

export const AmenitiesInnerWrapTop = styled.div(
  props => `
      width: 100%;
      display: flex;
      padding-top: ${props.theme.spacing.small.s3};
  `
);

export const TickIconWrapTop = styled.div(
  props => `
      width: 1.3rem;
      height: 1.3rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: ${props.theme.spacing.small.s3};
  `
);

export const AmenitiesTextWrapTop = styled.div(
  props => `
      width:90%;
      display: flex;
  `
);

export const AmenitesTopText = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.grey.base};
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  `
);

export const MoreAmenitesText = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.blue.base};
    cursor: pointer;
  `
);

export const RoomPriceTop = styled.div(
  props => `
      width: 40%;
      display: flex;
      flex-direction: column;  
      align-items: flex-end;
  `
);

export const OriginalPriceTop = styled.p(
  props => `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.grey.base};
      text-decoration: line-through;
  `
);

export const NewPriceTop = styled.p(
  props => `
      font-size: ${props.theme.font.large.font18};
      color: ${props.theme.colors.black.base};
      letter-sapcing: ${props.theme.font.letterSpacing.large};
  `
);

export const DealWrapTop  = styled.div(
  props => `
      width: 90%;
      display: flex;
      justify-content: flex-end;
      padding-top: ${props.theme.spacing.small.s5};  
  `
);

export const DealMainTextTop = styled.p(
  props => `
      font-size: ${props.theme.font.small.font11};
      color: ${props.theme.colors.red.base};
      line-height: ${props.theme.font.lineHeight.base};
      text-align: ${props.theme.font.textAlign.right};
  `
);

export const OtherRoomWrapTop = styled.div(
  props => `
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px solid ${props.theme.colors.grey.lightdd};
      border-top: none;
      padding: ${props.theme.spacing.base};
  `
);

export const OtherRoomLoader = styled.div(
  props => `
    width: 42%;
    height: 2rem;
    background-image: linear-gradient(to left, #f4f4f4, #ececec);
  `
)

export const SoldOutWrapTop = styled.div(
  props => `
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid ${props.theme.colors.grey.lightdd};
    border-top: none;
    padding: ${props.theme.spacing.base};
  `
);

export const OtherRoomText = styled.a(
  props => `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.blue.base};
      font-weight: ${props.theme.font.fontWeight.black};
      text-transform: ${props.theme.font.textTransform.upper};
      cursor: pointer;
      &:hover{
        color: ${props.theme.colors.blue.base};
      }
  `
);

export const BookRoomBtn = styled.a(
  props => `
      display: flex;
      align-items: flex-end;
      padding: ${props.theme.spacing.small.s8} ${props.theme.spacing.large.l25};
      box-shadow: 0 1px 7px 0 ${props.theme.colors.black.light2};
      background-image: linear-gradient(95deg, #53b2fe 1%, #065af3 130%);  
      text-transform: ${props.theme.font.textTransform.upper};
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.white.base};
      font-weight: ${props.theme.font.fontWeight.black};
      border-radius: 3.5rem;
      outline: none;
      cursor: pointer;
      &:hover{
        color: ${props.theme.colors.white.base};
      }
  `
);

export const SoldOutWrapperDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    width: 100%;
    background-color:${props.theme.colors.red.lightRed};
    justify-content: center;
    align-items: center;
`,
);

export const IconWrapperSpan = styled.span(
  props => `
    margin: 0 ${props.theme.spacing.base} 0 0;
`,
);

export const SoldOutInnerDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.base} ${props.theme.spacing.xlarge} ${props.theme.spacing.base};
`,
);

export const TimerImage = styled.img(
  props => `

    margin-right:${props.theme.spacing.base};
    width: 4.2rem;
    height: 4.2rem;

`,
);

export const SoldOutRoomInfoTopBlock = styled.div(
  props => `
      width:100%;
      display: flex;
      justify-content: space-between;
      border: solid 0.7px ${props.theme.colors.grey.lightdd};
      height: 16.5rem;
  `
);

export const SoldOutTextWrappDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
`,
);

export const FirstTxtPara = styled.p(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  color:${props.theme.colors.red.base};
  font-weight:bold;
  font-size:${props.theme.font.large.font16};
  padding-bottom:${props.theme.spacing.xsmall};
  text-transform: uppercase;
`,
);

export const AlternateDateLink = styled.a(
  props => `
  display:inline-flex;
  cursor: pointer;
  font-size:${props.theme.font.base};
  padding-top:${props.theme.spacing.xsmall};

  color: ${props.theme.colors.goBrand.blue};
  &:hover{
    color: ${props.theme.colors.goBrand.blue};
  }
`,
);

export const YouGetPriceText = styled.p`
  color: #fff;
  font-size: 1rem;
  background-color: #249995;
  border-radius: 3px;
  padding: 1px 2px 1px 5px;
  margin:3px 0;
`;

export const BoldText = styled.span`
  font-weight: 900;
`;
